import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ExitIntentPopup from './ExitIntentPopup';

export default function ExercicioGratisNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <ExitIntentPopup />
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-charcoal-950/96 backdrop-blur-lg border-b border-gold-500/15'
            : 'bg-charcoal-950/70 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-24">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
                alt="Bia Holmes"
                className="w-[72px] h-[72px] object-contain rounded-full bg-white p-0.5 flex-shrink-0 group-hover:scale-110 group-hover:drop-shadow-[0_0_14px_rgba(201,164,64,0.55)] transition-all duration-300"
              />
              <div className="hidden sm:flex flex-col">
                <span className="font-['Playfair_Display'] text-lg font-semibold text-white leading-tight">
                  Bia Holmes
                </span>
                <span className="text-xs text-gold-400 tracking-widest uppercase font-['Montserrat']">
                  Exercícios de PNL
                </span>
              </div>
            </Link>

            {/* Nav links */}
            <div className="flex items-center gap-4 sm:gap-6">
              <Link
                to="/planos#exercicios-pnl"
                className="hidden md:block font-['Montserrat'] text-xs uppercase tracking-wider text-white/60 hover:text-gold-400 transition-colors whitespace-nowrap"
              >
                Ver Planos
              </Link>
              <Link
                to="/exercicios-pnl"
                className="hidden md:block font-['Montserrat'] text-xs uppercase tracking-wider text-white/60 hover:text-gold-400 transition-colors whitespace-nowrap"
              >
                Todos os Exercícios
              </Link>
              <Link
                to="/auth/login"
                className="px-5 py-2 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 font-['Montserrat'] text-xs font-bold rounded-lg hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap tracking-wide"
              >
                Entrar
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
